var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-nowrap"},_vm._l((parseInt(_vm.size)),function(i){return _c('v-icon',{attrs:{"dense":"","color":"secondary"}},[_vm._v("mdi-star")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }